export default __webpack_public_path__ + "static/section3_feature1-04f040022aacaba8dfe88a121d5418a0.png";